import React from "react";

const DocumentContainer = ({fileUrl}) => {
  if (!fileUrl) {
    return <p>Aucun fichier à visualiser</p>;
  }

  return (
    <iframe
      className="h-full min-h-[65vh] w-full border-0"
      src={fileUrl}
      title="Aperçu de la facture PDF"
    />
  );
};

export default DocumentContainer;
